import type { MultiStepFormData } from "@/stores";

export const VALUE_TYPE_SUBTITLE = "subtitle";

export const buildAddressCardData = (
  addressFormData: MultiStepFormData["addressInformationFormData"],
  hasSameShipping: boolean,
) => {
  if (!addressFormData) return [];

  if (hasSameShipping) {
    return [
      {
        label: "Street Address 1",
        value: addressFormData.billingAddress.addressLineOne,
      },
      {
        label: "Street Address 2",
        value: addressFormData.billingAddress.addressLineTwo,
      },
      {
        label: "City",
        value: addressFormData.billingAddress.city,
      },
      {
        label: "State",
        value: addressFormData.billingAddress.state,
      },
      {
        label: "ZIP Code",
        value: addressFormData.billingAddress.zipCode,
      },
      {
        label: "Billing address",
        value: "Same as shipping",
      },
    ];
  }

  return [
    {
      label: "Billing address",
      value: VALUE_TYPE_SUBTITLE,
    },
    {
      label: "Address line 1",
      value: addressFormData.billingAddress.addressLineOne,
    },
    {
      label: "Address line 2",
      value: addressFormData.billingAddress.addressLineTwo,
    },
    {
      label: "City",
      value: addressFormData.billingAddress.city,
    },
    {
      label: "State",
      value: addressFormData.billingAddress.state,
    },
    {
      label: "ZIP Code",
      value: addressFormData.billingAddress.zipCode,
    },

    {
      label: "Shipping address",
      value: VALUE_TYPE_SUBTITLE,
    },
    {
      label: "Address line 1",
      value: addressFormData.shippingAddress?.addressLineOne,
    },
    {
      label: "Address line 2",
      value: addressFormData.shippingAddress?.addressLineTwo,
    },
    {
      label: "City",
      value: addressFormData.shippingAddress?.city,
    },
    {
      label: "State",
      value: addressFormData.shippingAddress?.state,
    },
    {
      label: "ZIP Code",
      value: addressFormData.shippingAddress?.zipCode,
    },
  ];
};
